'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'users';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f0c0';
var svgPathData = ['M160 480c8.8 0 16-7.2 16-16l0-24c0-66.3 53.7-120 120-120l48 0c66.3 0 120 53.7 120 120l0 24c0 8.8 7.2 16 16 16l-320 0zM400 128a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z', 'M320 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM296 320c-66.3 0-120 53.7-120 120l0 24c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24c0-83.9 68.1-152 152-152l48 0c83.9 0 152 68.1 152 152l0 24c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24c0-66.3-53.7-120-120-120l-48 0zm135.4-77.2c7.8-7.6 14.9-16 21-25 8.3 4 17.7 6.2 27.6 6.2 35.3 0 64-28.7 64-64s-28.7-64-64-64c-1.1 0-2.1 0-3.2 .1-2.2-10.8-5.5-21.3-9.8-31.2 4.2-.6 8.6-.9 12.9-.9 53 0 96 43 96 96s-43 96-96 96c-17.7 0-34.3-4.8-48.6-13.2zM160 64c4.4 0 8.7 .3 12.9 .9-4.3 9.9-7.6 20.4-9.8 31.2-1.1-.1-2.1-.1-3.2-.1-35.3 0-64 28.7-64 64s28.7 64 64 64c9.9 0 19.2-2.2 27.5-6.2 6.1 9.1 13.2 17.4 21 25-14.2 8.4-30.8 13.2-48.6 13.2-53 0-96-43-96-96s43-96 96-96zM149.4 304c-9.6 10.3-18.1 21.6-25.3 33.8-52.3 9.4-92.1 55.2-92.1 110.2l0 16c0 8.8-7.2 16-16 16S0 472.8 0 464l0-16c0-79.5 64.5-144 144-144l5.4 0zm366.6 33.8c-7.2-12.1-15.7-23.5-25.3-33.8l5.3 0c79.5 0 144 64.5 144 144l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-55-39.7-100.8-92.1-110.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUsers = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;